import {Action} from '@ngrx/store';
import * as AuthActions from './actions';
import { SKey } from '../../utils/static/s-str';

const initialState = {
    isLoggedIn: !!localStorage.getItem(SKey.TOKEN),
    token: localStorage.getItem(SKey.TOKEN),
    currentUser: {
        email: 'mail@example.com',
        picture: null
    }
};

export function authReducer(
    state = initialState,
    action: AuthActions.LoginUser
) {
    switch (action.type) {
        case AuthActions.LOGIN_USER:
            localStorage.setItem(SKey.TOKEN, action.payload);
            return {
                ...state,
                isLoggedIn: true,
                token: action.payload
            };
            break;
        case AuthActions.LOGOUT_USER:
            break;
        case AuthActions.LOAD_USER:
            break;
        default:
            return state;
    }
}
